import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PhoneFrame } from '../PhoneMockups';
import { AppleIcon, GooglePlayIcon } from '../StoreIcons';
import { APP_STORE_URL, PLAY_STORE_URL, openStore } from '../appLinks';

export function ForListeners() {
  const navigate = useNavigate();

  return (
    <>
      <div className="page-hero">
        <div className="ph-text">
          <p className="s-eyebrow">For Listeners</p>
          <h1 className="hero-h1" style={{ fontSize: 'clamp(44px,5vw,72px)', marginBottom: 24 }}>Discover, support, and<br /><em>hire the artists you love.</em></h1>
          <p className="s-body" style={{ marginBottom: 36 }}>Tarana is where you find new music — and where you book the talent behind it for your own events.</p>
          <div className="cta-actions">
            <button className="btn btn-primary btn-lg" onClick={() => navigate('/redirect')}>Get the app</button>
          </div>
        </div>
        <div className="ph-phone">
          <PhoneFrame style={{ width: 260, height: 540 }} screen="feed" frameWidth={260} screenQuery="hideStories=1" />
        </div>
      </div>

      <div className="s-bg1" id="page-features">
        <div className="s-wrap">
          <div className="fcards">
            <div className="fcard">
              <svg className="fcard-icon" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round"><circle cx="14" cy="14" r="10" /><line x1="14" y1="4" x2="14" y2="6" /><line x1="14" y1="22" x2="14" y2="24" /><line x1="4" y1="14" x2="6" y2="14" /><line x1="22" y1="14" x2="24" y2="14" /></svg>
              <div className="fcard-title">Discover beyond the algorithm</div>
              <div className="fcard-body">Find emerging and independent artists by genre, language, and location — and be the first to hear what's next, before it goes mainstream.</div>
            </div>
            <div className="fcard">
              <svg className="fcard-icon" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round"><path d="M14 4l2.5 5 5.5.8-4 3.9.9 5.5L14 17l-4.9 2.2.9-5.5-4-3.9 5.5-.8z" /></svg>
              <div className="fcard-title">Follow and support</div>
              <div className="fcard-body">Follow your favourite artists, keep up with their releases and updates, and support the people behind the music you love.</div>
            </div>
            <div className="fcard">
              <svg className="fcard-icon" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="8" width="24" height="16" rx="2" /><path d="M8 8V6a6 6 0 0112 0v2" /><circle cx="14" cy="16" r="2" /></svg>
              <div className="fcard-title">Hire talent for your event</div>
              <div className="fcard-body">Planning a wedding, party, show, or event? Find and book DJs, bands, and solo performers directly through Tarana — browse profiles, check credits, and send a request in minutes.</div>
            </div>
            <div className="fcard">
              <svg className="fcard-icon" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round"><path d="M5 13l5 5L23 8" /></svg>
              <div className="fcard-title">Book with confidence</div>
              <div className="fcard-body">Every booking is handled with escrow-protected payments and clear, on-platform agreements, so both you and the artist are protected from start to finish.</div>
            </div>
          </div>
        </div>
      </div>

      <section className="s-bg4 cta-strip">
        <h2 className="s-h2">Find your next favourite —<br /><em>or your next performer.</em></h2>
        <p className="s-body">Start exploring thousands of artists and book talent for your next event.</p>
        <div className="app-badges">
          <div className="app-badge" onClick={() => openStore(APP_STORE_URL)}>
            <AppleIcon />
            <div className="app-badge-text"><span className="app-badge-sub">Download on the</span><span className="app-badge-name">App Store</span></div>
          </div>
          <div className="app-badge" onClick={() => openStore(PLAY_STORE_URL)}>
            <GooglePlayIcon className="app-badge-play-icon" />
            <div className="app-badge-text"><span className="app-badge-sub">Get it on</span><span className="app-badge-name">Google Play</span></div>
          </div>
        </div>
      </section>
    </>
  );
}
